import {InputText} from "primereact/inputtext";
import {Message} from "primereact/message";
import React, {useState} from "react";
import {Button} from "primereact/button";
import {formValid, getKeyValue, urlValidator} from "../../utils/Utils";

import {AppContext} from "../../HomePage";

const ProductAdd = (props) => {

    const {t, toast, setError} = React.useContext(AppContext);
    const [product, setProduct] = useState({product_url: ""});
    const [formErrors, setFormErrors] = useState({product_url: ""});

    const add = () => {
        checkErrors(product).then(formErrors=> {
            if (formValid(formErrors))
                props.add(product);
            else
                setFormErrors(formErrors);
        });
    }

    const onChange = (e) =>{
        const { key, value } = getKeyValue(e);
        setFormErrors({...formErrors, [key]: checkError(key, value)});
        setProduct({...product, [key] : value});
    };

    const onEnter = (e) => e.key === "Enter" && add();

    const errorClass = (key) => {
        return formErrors[key] && formErrors[key].length > 0
    };

    const checkError = (key, value) => {
        let errorText = "";
        if (key === "product_url") {
            errorText =  urlValidator(value, t);
        }
        return errorText;
    };

    const checkErrors = async (product) => {
        let errors = { ...formErrors };
        Object.entries(product).forEach(([key, value]) => {
            errors[key] = checkError(key, value);
        });
        setFormErrors(errors);
        return errors;
    };

    return <React.Fragment>
        {/* Header: icon badge + title */}
        <div style={{display: 'flex', alignItems: 'center', gap: 12, marginBottom: 6}}>
            <span style={{width: 40, height: 40, borderRadius: 10, background: '#ecfdf5', color: '#059669',
                          display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0}}>
                <i className="pi pi-plus" style={{fontSize: '1.1rem'}}/>
            </span>
            <div style={{fontWeight: 700, fontSize: '1.15rem'}}>{t('product.add_product')}</div>
        </div>
        <p style={{color: '#6b7280', fontSize: '.85rem', margin: '0 0 20px'}}>{t('product.add_product_hint')}</p>

        {/* URL field with leading link icon */}
        <div>
            <label htmlFor="product_url" style={{display: 'block', fontWeight: 600, fontSize: '.85rem',
                                                  color: '#374151', marginBottom: 6}}>
                {t('product.product_url')}
            </label>
            <span className="p-input-icon-left" style={{display: 'block'}}>
                <i className="pi pi-link"/>
                <InputText id="product_url" name="product_url" value={product.product_url}
                           onChange={onChange} onKeyDown={onEnter} placeholder="https://..."
                           className={errorClass("product_url") ? "p-invalid" : ""}
                           style={{width: '100%'}} autoFocus={true}/>
            </span>
            {errorClass("product_url") &&
                (<Message severity="error" text={formErrors.product_url}
                          style={{marginTop: 10, width: '100%', justifyContent: 'flex-start'}}/>)}
        </div>

        {/* Footer actions */}
        <div style={{display: 'flex', gap: 10, marginTop: 24}}>
            <Button id="cancel" label={t('actions.cancel')} icon="pi pi-angle-double-left"
                    className="p-button-text p-button-secondary" style={{flex: 1}} onClick={props.cancel}/>
            <Button id="add" label={t('actions.add')} icon="pi pi-plus"
                    className="p-button-success" style={{flex: 1}} onClick={add}/>
        </div>
    </React.Fragment>;
};
export default ProductAdd;